var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCommon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.8C0 8.31958 0 6.07937 0.871948 4.36808C1.63893 2.86278 2.86278 1.63893 4.36808 0.871948C6.07937 0 8.31958 0 12.8 0H35.2C39.6804 0 41.9206 0 43.6319 0.871948C45.1372 1.63893 46.3611 2.86278 47.1281 4.36808C48 6.07937 48 8.31958 48 12.8V35.2C48 39.6804 48 41.9206 47.1281 43.6319C46.3611 45.1372 45.1372 46.3611 43.6319 47.1281C41.9206 48 39.6804 48 35.2 48H12.8C8.31958 48 6.07937 48 4.36808 47.1281C2.86278 46.3611 1.63893 45.1372 0.871948 43.6319C0 41.9206 0 39.6804 0 35.2V12.8Z",
    fill: "url(#paint0_linear_1917_38494)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8673 10.0645H30.923C30.5468 10.0645 30.2419 10.3733 30.2419 10.7543V13.3759H27.3191C25.815 13.3775 24.5962 14.612 24.5946 16.1354V20.5128H22.5139C22.1377 20.5128 21.8328 20.8217 21.8328 21.2027V23.3101H17.7585V20.6885C17.7585 20.3075 17.4535 19.9987 17.0773 19.9987H11.1328C10.7566 19.9987 10.4517 20.3075 10.4517 20.6885V27.3113C10.4517 27.6924 10.7566 28.0012 11.1328 28.0012H17.0773C17.4535 28.0012 17.7585 27.6924 17.7585 27.3113V24.6898H21.8328V26.7972C21.8328 27.1782 22.1377 27.487 22.5139 27.487H24.5946V31.8645C24.5962 33.3879 25.815 34.6224 27.3191 34.624H30.2419V37.2455C30.2419 37.6266 30.5468 37.9354 30.923 37.9354H36.8673C37.2435 37.9354 37.5484 37.6266 37.5484 37.2455V30.6227C37.5484 30.2417 37.2435 29.9329 36.8673 29.9329H30.923C30.5468 29.9329 30.2419 30.2417 30.2419 30.6227V33.2443H27.3191C26.567 33.2435 25.9577 32.6261 25.9569 31.8645V27.487H27.7401C28.1163 27.487 28.4212 27.1782 28.4212 26.7972V21.2027C28.4212 20.8217 28.1163 20.5128 27.7401 20.5128H25.9569V16.1354C25.9577 15.3738 26.567 14.7564 27.3191 14.7556H30.2419V17.3771C30.2419 17.7582 30.5468 18.067 30.923 18.067H36.8673C37.2435 18.067 37.5484 17.7582 37.5484 17.3771V10.7543C37.5484 10.3733 37.2435 10.0645 36.8673 10.0645Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1917_38494",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCA549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39531"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCommon);
export default __webpack_public_path__ + "static/media/iconCommon.6b48e3795ff70bc9852748d39524fb03.svg";
export { ForwardRef as ReactComponent };